import { ПреобразуйСтрокуВЛатиницу, ПреобразуйСтрокуИзЛатиницы } from 'utils/yarolit';

export const cyrillicToLatin = (str) => {
    return ПреобразуйСтрокуВЛатиницу(str).replace(/ /g, '_');
}

export const latinToCyrillic = (str) => {
    return ПреобразуйСтрокуИзЛатиницы(str).replace(/\_/g, ' ');
}
